import { render, staticRenderFns } from "./UserTable.vue?vue&type=template&id=12bc1f9b&scoped=true"
import script from "./UserTable.vue?vue&type=script&lang=js"
export * from "./UserTable.vue?vue&type=script&lang=js"
import style0 from "./UserTable.vue?vue&type=style&index=0&id=12bc1f9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bc1f9b",
  null
  
)

export default component.exports